module.exports = __webpack_public_path__ + "img/sms.b2d2c0ec.svg";